import React, {useCallback} from "react";
import sass from "./desc.module.sass";
import DropMenu from "../DropMenu";
import { ReactComponent as ImageIcon } from "images/FileImage.svg";
import { ReactComponent as ChangeFile } from "images/EditorIcon.svg";
import { ReactComponent as DownloadFile } from "images/DownloadGreenIcon.svg";
import { SystemDescriptionResponse } from "libs/apiClient/data-contracts";

interface IAddImage {
	isStructure: boolean;
	clickName: (e: React.MouseEvent<HTMLSpanElement>) => void;
	desc: SystemDescriptionResponse;
	target: HTMLSpanElement | null;
	menuRef: React.MutableRefObject<HTMLDivElement | null>;
	clickMenuRef: (event: React.MouseEvent<HTMLLabelElement>) => void;
	changeEvent: (e: React.ChangeEvent<HTMLInputElement>) => void;
	getImageFile: () => void;
	addImage: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddImage: React.FC<IAddImage> = ({
	isStructure,
	clickName,
	desc,
	target,
	menuRef,
	clickMenuRef,
	changeEvent,
	getImageFile,
	addImage,
}) => {
	return (
		<div className={sass.images}>
			{desc[isStructure ? "structureFile" : "file"] ? (
				<p onClick={clickName}>
					<ImageIcon />
					<span>{desc[isStructure ? "structureFile" : "file"]}</span>
				</p>
			) : (
				<span />
			)}
			{target && (
				<DropMenu click={() => {}} clear ref={menuRef} target={target}>
					<label className={sass.dropItem} onClick={clickMenuRef}>
						<input accept="image/png, image/gif, image/jpeg" onChange={changeEvent} type={"file"} hidden={true} />
						<ChangeFile className={sass.change} width={12} height={12} /> Изменить
					</label>
					<p onClick={getImageFile} className={sass.dropItem}>
						<DownloadFile className={sass.download} /> Скачать
					</p>
				</DropMenu>
			)}
			{/*{!confirm && (*/}
			<label onClick={clickMenuRef}>
				<input accept="image/png, image/gif, image/jpeg" onChange={addImage} type={"file"} hidden={true} />
				{desc[isStructure ? "structureFile" : "file"] ? "Изменить" : "Прикрепить изображение"}
			</label>
			{/*)}*/}
		</div>
	);
};

export default AddImage;
